import type { MessageDescriptor } from "@lingui/core";
import { useLingui } from "@lingui/react";
import type { TRPCClientErrorLike } from "@trpc/client";

type FieldErrorIssue = {
	params?: { i18n?: MessageDescriptor };
	message?: string;
};

export const useVehicleSubmitError = (error: TRPCClientErrorLike<any> | null | undefined): string | undefined => {
	const { i18n } = useLingui();
	if (!error) {
		return undefined;
	}
	const issues = (error.data?.errors?.fieldErrors?.plate as FieldErrorIssue[] | undefined) ?? [];
	const descriptor = issues[0]?.params?.i18n;
	if (descriptor) {
		return i18n._(descriptor);
	}
	return error.message || undefined;
};
